import { render, staticRenderFns } from "./AstaRose.vue?vue&type=template&id=580be584&scoped=true&"
import script from "./AstaRose.vue?vue&type=script&lang=js&"
export * from "./AstaRose.vue?vue&type=script&lang=js&"
import style0 from "./AstaRose.vue?vue&type=style&index=0&id=580be584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580be584",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('580be584')) {
      api.createRecord('580be584', component.options)
    } else {
      api.reload('580be584', component.options)
    }
    module.hot.accept("./AstaRose.vue?vue&type=template&id=580be584&scoped=true&", function () {
      api.rerender('580be584', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AstaRose.vue"
export default component.exports